/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.20",
    versionName: "0.2.0-nightly.2025.8.20",
    versionChannel: "nightly",
    buildDate: "2025-08-20T00:09:10.789Z",
    commitHash: "4821a6c9d3dc09343e3b6d3e045b7630e621bd9f",
};
